import _regeneratorRuntime from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es6.promise";
import _slicedToArray from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import { getActions, getCompetedActions, getMyActions, getMyCompletedActions, getMeetingActions, storeAction, updateAction, updateMyAction, destroyAction } from "src/models/Action";
import errorDialog from "src/functions/function-show-error-message";
import getErrorPayload from "src/functions/get-error-payload";
import { commitPagination, hasNextPage } from "src/store/utils/pagination"; // Init state

var initState = function initState() {
  return {
    actions: [],
    completedActions: [],
    myActions: [],
    myCompletedActions: [],
    meetingActions: [],
    completedActionsPagination: {
      currentPage: 0,
      total_pages: 1
    },
    hasMoreCompletedActions: true,
    myCompletedActionsPagination: {
      currentPage: 0,
      total_pages: 1
    },
    hasMoreMyCompletedActions: true,
    loading: {
      actions: false,
      completedActions: false,
      myCompletedActions: false
    }
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  setActions: function setActions(state, payload) {
    state.actions = payload;
  },
  setCompletedActions: function setCompletedActions(state, payload) {
    state.completedActions = payload;
  },
  appendCompletedActions: function appendCompletedActions(state, payload) {
    var existingIds = new Set(state.completedActions.map(function (item) {
      return item.id;
    }));
    var newItems = payload.filter(function (item) {
      return !existingIds.has(item.id);
    });
    state.completedActions = [].concat(_toConsumableArray(state.completedActions), _toConsumableArray(newItems));
  },
  updateCompletedActionsPagination: function updateCompletedActionsPagination(state, pagination) {
    state.completedActionsPagination.currentPage = pagination.currentPage;
    state.completedActionsPagination.total_pages = pagination.total_pages;
  },
  setHasMoreCompletedActions: function setHasMoreCompletedActions(state, value) {
    state.hasMoreCompletedActions = value;
  },
  setCompletedActionsLoading: function setCompletedActionsLoading(state, payload) {
    state.loading.completedActions = payload;
  },
  setMyActions: function setMyActions(state, payload) {
    // sort the payload array
    state.myActions = payload.sort(function (a, b) {
      // if either object has a non-null deadline
      return a.deadline !== null || b.deadline !== null ? a.deadline !== null ? -1 : 1 // place the object with a non-null deadline first
      : new Date(a.planned_date_time) - new Date(b.planned_date_time); // otherwise, sort by planned_date_time
    });
  },
  setMyCompletedActions: function setMyCompletedActions(state, payload) {
    state.myCompletedActions = payload;
  },
  appendMyCompletedActions: function appendMyCompletedActions(state, payload) {
    var existingIds = new Set(state.myCompletedActions.map(function (item) {
      return item.id;
    }));
    var newItems = payload.filter(function (item) {
      return !existingIds.has(item.id);
    });
    state.myCompletedActions = [].concat(_toConsumableArray(state.myCompletedActions), _toConsumableArray(newItems));
  },
  updateMyCompletedActionsPagination: function updateMyCompletedActionsPagination(state, pagination) {
    state.myCompletedActionsPagination.currentPage = pagination.currentPage;
    state.myCompletedActionsPagination.total_pages = pagination.total_pages;
  },
  setHasMoreMyCompletedActions: function setHasMoreMyCompletedActions(state, value) {
    state.hasMoreMyCompletedActions = value;
  },
  setMyCompletedActionsLoading: function setMyCompletedActionsLoading(state, payload) {
    state.loading.myCompletedActions = payload;
  },
  setMeetingActions: function setMeetingActions(state, payload) {
    state.meetingActions = payload;
  },
  setActionsLoading: function setActionsLoading(state, payload) {
    state.loading.actions = payload;
  },
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  fetchMyActions: function fetchMyActions(_ref) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, _myCompletedActions$d, _myCompletedActions$d2, _yield$Promise$all, _yield$Promise$all2, myActions, myCompletedActions;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              commit("setActionsLoading", true);
              commit("setHasMoreMyCompletedActions", true);
              _context.prev = 3;
              _context.next = 6;
              return Promise.all([getMyActions(), getMyCompletedActions(1)]);

            case 6:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              myActions = _yield$Promise$all2[0];
              myCompletedActions = _yield$Promise$all2[1];
              commit("setMyActions", myActions.data.data);
              commit("setMyCompletedActions", myCompletedActions.data.data);
              commitPagination(commit, (_myCompletedActions$d = myCompletedActions.data) === null || _myCompletedActions$d === void 0 ? void 0 : (_myCompletedActions$d2 = _myCompletedActions$d.meta) === null || _myCompletedActions$d2 === void 0 ? void 0 : _myCompletedActions$d2.pagination, {
                update: "updateMyCompletedActionsPagination",
                setHasMore: "setHasMoreMyCompletedActions"
              });
              commit("setActionsLoading", false);
              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](3);
              console.log(getErrorPayload(_context.t0));
              commit("setActionsLoading", false);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 16]]);
    }))();
  },
  fetchActions: function fetchActions(_ref2) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, group, _completedActionsResp, _completedActionsResp2, _yield$Promise$all3, _yield$Promise$all4, actionsResponse, completedActionsRespose;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              commit("setActionsLoading", true);
              commit("setHasMoreCompletedActions", true);
              group = _this.getters["Group/group"];
              _context2.prev = 4;
              _context2.next = 7;
              return Promise.all([getActions(group.id), getCompetedActions(group.id, 1)]);

            case 7:
              _yield$Promise$all3 = _context2.sent;
              _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
              actionsResponse = _yield$Promise$all4[0];
              completedActionsRespose = _yield$Promise$all4[1];
              commit("setActions", actionsResponse.data.data);
              commit("setCompletedActions", completedActionsRespose.data.data);
              commitPagination(commit, (_completedActionsResp = completedActionsRespose.data) === null || _completedActionsResp === void 0 ? void 0 : (_completedActionsResp2 = _completedActionsResp.meta) === null || _completedActionsResp2 === void 0 ? void 0 : _completedActionsResp2.pagination, {
                update: "updateCompletedActionsPagination",
                setHasMore: "setHasMoreCompletedActions"
              });
              commit("setActionsLoading", false);
              _context2.next = 21;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](4);
              console.log(getErrorPayload(_context2.t0));
              commit("setActionsLoading", false);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 17]]);
    }))();
  },
  fetchMoreCompletedActions: function fetchMoreCompletedActions(_ref3) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, state, group, nextPage, _response$data, _response$data2, _response$data2$meta, response;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit, state = _ref3.state;
              group = _this2.getters["Group/group"];

              if (!(state.loading.completedActions || state.loading.actions)) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              if (hasNextPage(state, "completedActionsPagination")) {
                _context3.next = 7;
                break;
              }

              commit("setHasMoreCompletedActions", false);
              return _context3.abrupt("return");

            case 7:
              commit("setCompletedActionsLoading", true);
              nextPage = state.completedActionsPagination.currentPage + 1;
              _context3.prev = 9;
              _context3.next = 12;
              return getCompetedActions(group.id, nextPage);

            case 12:
              response = _context3.sent;
              commit("appendCompletedActions", Array.isArray((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) ? response.data.data : []);
              commitPagination(commit, (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$meta = _response$data2.meta) === null || _response$data2$meta === void 0 ? void 0 : _response$data2$meta.pagination, {
                update: "updateCompletedActionsPagination",
                setHasMore: "setHasMoreCompletedActions"
              });
              commit("setCompletedActionsLoading", false);
              _context3.next = 21;
              break;

            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](9);
              commit("setCompletedActionsLoading", false);

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[9, 18]]);
    }))();
  },
  fetchMoreMyCompletedActions: function fetchMoreMyCompletedActions(_ref4) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var commit, state, nextPage, _response$data3, _response$data4, _response$data4$meta, response;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit, state = _ref4.state;

              if (!(state.loading.myCompletedActions || state.loading.actions)) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              if (hasNextPage(state, "myCompletedActionsPagination")) {
                _context4.next = 6;
                break;
              }

              commit("setHasMoreMyCompletedActions", false);
              return _context4.abrupt("return");

            case 6:
              commit("setMyCompletedActionsLoading", true);
              nextPage = state.myCompletedActionsPagination.currentPage + 1;
              _context4.prev = 8;
              _context4.next = 11;
              return getMyCompletedActions(nextPage);

            case 11:
              response = _context4.sent;
              commit("appendMyCompletedActions", Array.isArray((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.data) ? response.data.data : []);
              commitPagination(commit, (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : (_response$data4$meta = _response$data4.meta) === null || _response$data4$meta === void 0 ? void 0 : _response$data4$meta.pagination, {
                update: "updateMyCompletedActionsPagination",
                setHasMore: "setHasMoreMyCompletedActions"
              });
              commit("setMyCompletedActionsLoading", false);
              _context4.next = 20;
              break;

            case 17:
              _context4.prev = 17;
              _context4.t0 = _context4["catch"](8);
              commit("setMyCompletedActionsLoading", false);

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[8, 17]]);
    }))();
  },
  fetchMeetingActions: function fetchMeetingActions(_ref5) {
    var commit = _ref5.commit;
    commit("setActionsLoading", true);
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    return new Promise(function (resolve) {
      getMeetingActions(group.id, meeting.id).then(function (response) {
        commit("setMeetingActions", response.data.data);
        commit("setActionsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setActionsLoading", false);
      });
    });
  },
  createAction: function createAction(_ref6, request) {
    var commit = _ref6.commit;
    commit("setActionsLoading", true);
    var group = this.getters["Group/group"];

    if (request["isMeeting"]) {
      var meeting = this.getters["Meeting/meeting"];
      request["meeting_id"] = meeting.id;
    }

    request["user_id"] = request["user"]["id"];
    return new Promise(function (resolve) {
      storeAction(group.id, request).then(function () {
        commit("setActionsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setActionsLoading", false);
      });
    });
  },
  editMyAction: function editMyAction(_ref7, request) {
    var commit = _ref7.commit;
    commit("setActionsLoading", true);
    var actionId = request["id"];
    return new Promise(function (resolve) {
      updateMyAction(actionId, request).then(function () {
        commit("setActionsLoading", false);
        resolve();
      }).catch(function (e) {
        commit("setActionsLoading", false);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  editAction: function editAction(_ref8, request) {
    var commit = _ref8.commit;
    commit("setActionsLoading", true);
    var group = this.getters["Group/group"];
    var actionId = request["id"];
    request["user_id"] = request["user"]["id"];
    return new Promise(function (resolve, reject) {
      updateAction(group.id, actionId, request).then(function () {
        commit("setActionsLoading", false);
        resolve();
      }).catch(function (e) {
        commit("setActionsLoading", false);
        console.log("error in edit action");
        reject(e);
      });
    });
  },
  remove: function remove(_ref9, id) {
    var commit = _ref9.commit;
    commit("setActionsLoading", true);
    var group = this.getters["Group/group"];
    return new Promise(function (resolve) {
      destroyAction(group.id, id).then(function (response) {
        commit("setActionsLoading", false);
        resolve(response);
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setActionsLoading", false);
      });
    });
  }
}; // Getter functions

var getters = {
  actions: function actions(state) {
    return state.actions;
  },
  completedActions: function completedActions(state) {
    return state.completedActions;
  },
  hasMoreCompletedActions: function hasMoreCompletedActions(state) {
    return state.hasMoreCompletedActions;
  },
  completedActionsLoading: function completedActionsLoading(state) {
    return state.loading.completedActions;
  },
  myActions: function myActions(state) {
    return state.myActions;
  },
  myCompletedActions: function myCompletedActions(state) {
    return state.myCompletedActions;
  },
  hasMoreMyCompletedActions: function hasMoreMyCompletedActions(state) {
    return state.hasMoreMyCompletedActions;
  },
  myCompletedActionsLoading: function myCompletedActionsLoading(state) {
    return state.loading.myCompletedActions;
  },
  meetingActions: function meetingActions(state) {
    return state.meetingActions;
  },
  actionsLoading: function actionsLoading(state) {
    return state.loading.actions;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};